import { render, staticRenderFns } from "./ServiceCallChart.vue?vue&type=template&id=31acd20a&"
import script from "./ServiceCallChart.vue?vue&type=script&lang=js&"
export * from "./ServiceCallChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports